module.exports = __webpack_public_path__ + "img/OBCINA RENCE-VOGRSKO.bac10fc3.png";